export const colors = {
  darkBlue: '#1C2C54',
  white: '#ffffff',
  lightBlue: '#00C0FF',
};
